import * as React from "react"
import {Box, MenuItem} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import {handleLangPopoverClose} from "./signals";


export default function MaximalLayoutHeaderUserOption({ icon, text }) {
	return <MenuItem onClick={handleLangPopoverClose}>
		<IconSeeker icon={icon} />
		<Box component="span" sx={{ ml: 1 }}>
			{text}
		</Box>
	</MenuItem>
}